

export default function ActionBanque({ etat, setEtat, user }) {
    return (
        <select className="form-select" value={etat} onChange={e => setEtat(e.target.value)} >
            {
                user.roles.includes('ROLE_LIVRAISON') ? (
                    <option value="19">Livré</option>
                ) : (
                    <>
                        <option value="">Tout</option>
                        <option value="1">Consultation Central Risque</option>
                        <option value="2">Complément d'Information Banque</option>
                        <option value="3">Pré-Notification Banque</option>
                        <option value="12">Notification Banque</option>
                        <option value="18">Motocycle ASBA</option>
                        <option value="26">Motocycle DD</option>
                        <option value="27">ELECTRO / MEUBLE DD</option>
                        <option value="28">ELECTRO ASBA</option>
                        <option value="4">Notification Banque Diar Dzair</option>
                        <option value="17">Attente Apport</option>
                        <option value="5">Mobilisation electro meuble DD</option>
                        <option value="6">Mobilisation Stock ASBA</option>
                        <option value="16">Mobilisation Stock DD</option>
                        <option value="13">Livraison</option>
                        <option value="19">Livré</option>
                        <option value="14">Annulée</option>
                        <option value="11">Archive</option>
                        <option value="7">Controle Dossier Garantie Diar Dzair</option>
                        <option value="9">Réception  Garantie Banque</option>
                        <option value="8">Complément Garantie</option>
                        <option value="10">Suivi Dossier Au Niveau Banque</option>
                    </>
                )
            }
        </select>
    )
}